export function centerToBottomLeft(config) {
    const { width, height, contentWidth, contentHeight } = config;
    return {
        ...config,
        contentX: (width - contentWidth) / 2 + config.contentX,
        contentY: (height - contentHeight) / 2 - config.contentY,
        clipDevices: config.clipDevices.map(({ x, y }) => {
            return { x: x + width / 2, y: height / 2 - y };
        })
    };
}

export function bottomLeftToCenter(config) {
    const { width, height, contentWidth, contentHeight } = config;
    return {
        ...config,
        contentX: -width / 2 + contentWidth / 2 + config.contentX,
        contentY: height / 2 - contentHeight / 2 - config.contentY,
        clipDevices: config.clipDevices.map(({ x, y }) => {
            return { x: x - width / 2, y: height / 2 - y };
        })
    };
}



// WEBPACK FOOTER //
// ./src/catalog/caddy-utils.js